<template>
    <div class="page-container" ref="VideoSI" id="videosicontainer" v-images-loaded="loaded">
        <div class="bigscroller">
            <section id="VideoSi" class="sectionVideoSi">
                <span class="top watcher" ></span>
                <VideoS />
                <span class="bottom watcher"></span>
            </section>
            <Footer />
            <MobileFooter />
        </div>
    </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import { mapActions, mapGetters } from "vuex";
import Footer from "@/components/FooterHome";
import MobileFooter from "@/components/MobileFooterHome.vue";
import tagFunctions from '@/utils/tagFunctions.js';
import imagesLoaded from 'vue-images-loaded'
import VideoS from "@/components/VideoS";

export default {
    name: "VideoSI",
    props: ["id"],
    components: {
        Footer,
        MobileFooter,
        VideoS,
    },
    directives: {
        imagesLoaded
    },
    computed: {
        ...mapGetters([
        "getActiveSection",
        "getTriggerSpring",
        "getEdgeScrolling",
        "getScrollMotion",
        ]),
    },
    created() { },
    data() {
        return {
            showModal: false,
            wichModal: "",
            fixedLel: true,
            showTerms: false,
            showPrivacy: false,
            placesDirections: {
                videosiUp: (scrolled) => {
                    this.setActiveSection("VideoSi");
                    document.getElementById("app").scroll(0, scrolled);
                },
                videosiDown: (scrolled) => {
                    this.setActiveSection("VideoSi");
                    document.getElementById("app").scroll(0, scrolled);
                },
            },
        };
    },
    mounted() {
        this.setLoadStatus({ status: false })
        tagFunctions.evAuthenticationPush("Tecate 0.0 - Video si");
        tagFunctions.evPageViewPush('Video si')
        //this.checkRouteForInitialScroll();

        VueScrollTo.scrollTo(`#app`, 1, {
        container: "body",
        easing: "linear",
        offset: 0,
        force: true,
        cancelable: true,
        // onStart: function(element) {},
        // onDone: function(element) {},
        // onCancel: function() {},
        x: false,
        y: true,
        });
    },
    methods: {
        loaded() {
            this.setLoadStatus({ status: true })
        },
        ...mapActions({
            goToSection: "goToSection",
            setActiveSection: "setActiveSection",
            resetEdgeScrollingAction: "resetEdgeScrolling",
            setEdgeScrollingAction: "setEdgeScrolling",
            setLoadStatus: "setLoadStatus"
        }),
        popUpModal(modalType) {
            this.showModal = true;
            this.wichModal = modalType;
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/VideoSI.scss";
@import "~@/styles/variables.scss";
</style>